export default {
  hero: {
    titleLetter: 'A',
    titleRest: 'utomate your journey',
    titleIn: 'in',
    subtitle: 'Fast, lightweight and 100% safe',
    viewAccount: 'View Account',
    loginRegister: 'Login / Register',
    download: 'Download Unity-BOT',
    downloadNow: 'Download Now',
    version: 'Version {v}',
    versionSize: 'Version {v} • {size}',
    changelogUnavailable: 'No changelog available.',
    windowsReq: 'Windows 7+',
    ramReq: '4 GB RAM',
    javaReq: 'Java JDK 20+',
    admin: 'Admin',
    logoAlt: 'Unity-BOT Logo',
  },
  features: {
    title: 'Features',
    items: [
      { title: 'Easy Setup', desc: 'Auto-checker with easy advanced setup' },
      { title: 'Special Actions', desc: 'Automate quests with actions like using items, talking to NPCs and more' },
      { title: 'Active Community', desc: 'Active community with constant updates' },
    ],
  },
  download: {
    guidesTitle: 'Guides & Tutorials',
    communityTitle: 'Join the Community',
    tutorial: 'Tutorial',
    tutorialDesc: 'Watch our complete setup and configuration guide on YouTube',
    facebook: 'Facebook',
    facebookDesc: 'Join our community on Facebook for news and updates',
    whatsApp: 'WhatsApp',
    whatsAppDesc: 'Get instant support and connect with other users on WhatsApp',
    discord: 'Discord',
    discordDesc: 'Join our Discord server for live chat and technical support',
  },
  footer: {
    copyright: '© 2026 Unity-BOT. All rights reserved.',
    about: 'About',
    disclaimer: 'Unity-BOT is not affiliated with CipSoft GmbH. This software is for educational purposes only.',
  },
  about: {
    title: 'About Unity-BOT',
    botName: 'Unity-BOT v3.0 BETA',
    botDesc: '{name} is a sophisticated automation tool specifically engineered for TibiaME, representing years of development and community feedback. Built with precision and efficiency, it transforms the way players experience the game by automating tedious tasks while maintaining the highest standards of safety and performance.',
    coreFeatures: 'Core Features',
    smartHunt: 'Smart Auto-Hunting',
    smartHuntDesc: 'Advanced pathfinding system with customizable routes, creature priority selection, loot collection, and automatic backpack management',
    smartHeal: 'Intelligent Auto-Heal',
    smartHealDesc: 'Predictive healing algorithm that monitors HP/MP in real-time, with configurable thresholds and emergency failsafes',
    questAuto: 'Quest Automation',
    questAutoDesc: 'Complete quest workflows including NPC dialogues, item delivery, and multi-step mission execution',
    skillTrain: 'Auto-Skills Training',
    skillTrainDesc: 'Optimize skill progression with automated training routines for melee, distance, and magic skills',
    advancedCaps: 'Advanced Capabilities',
    actionScript: 'Action Scripting System',
    actionScriptDesc: 'Create custom sequences: use items, talk to NPCs, navigate coordinates, and chain multiple actions with conditional logic',
    autoChecker: 'Auto-Checker System',
    autoCheckerDesc: 'Real-time monitoring with configurable alerts for HP, MP, capacity, creature detection, and custom triggers',
    antiDetect: 'Anti-Detection Technology',
    antiDetectDesc: 'Human-like behavior patterns, randomized delays, and smart response times to maintain natural gameplay',
    resourceOpt: 'Resource Optimization',
    resourceOptDesc: 'Ultra-lightweight design (< 50MB RAM usage), minimal CPU footprint, and efficient network handling',
    safetyTitle: 'Safety & Performance',
    safety1: 'No memory injection - operates through screen capture and input simulation',
    safety2: 'Multi-layered failsafe systems to prevent character death',
    safety3: 'Built-in anti-stuck mechanisms and error recovery',
    safety4: 'Real-time statistics dashboard with session tracking',
    safety5: 'Regular updates and bug fixes from active development team',
    communityTitle2: 'Community & Support',
    communityDesc: 'Join thousands of players in our thriving community. Access comprehensive guides, share custom scripts, get technical support, and contribute to the bot\'s evolution. Our Discord server is active 24/7 with experienced users and developers ready to help.',
    tibiameTitle: 'TibiaME',
    tibiameDesc1: '{name} (Tibia Micro Edition) is the first massively multiplayer MMORPG for mobile devices, released in 2003. Based on the classic {classic}, the game allows hundreds of players to connect simultaneously to explore a colorful virtual world.',
    tibiameDesc2: 'In the game, you can explore mysterious lands, fight against hordes of evil creatures, solve ancient puzzles, find hidden treasures and grow in strength and power with each monster defeated.',
    tibiameAvailable: 'Available for iOS and Android',
    cipsoftTitle: 'CipSoft GmbH',
    cipsoftDesc: '{name} is an independent German online game developer, founded after the success of {classic} - one of the first MMORPGs in history, online since 1997. The company has over 100 employees and is internationally recognized.',
    cipsoftTibia: '{game} (1997) - Classic browser MMORPG',
    cipsoftTibiame: '{game} (2003) - First mobile MMORPG',
    cipsoftSettlers: '{game} - Strategy game',
    cipsoftPersist: '{game} - New zombie MMORPG (in development)',
    cipsoftAward: 'Winner of German Developer Award 2019 for Tibia',
    legalNotice: 'Legal Notice',
    legalDesc1: '{name} is an independent project and is not affiliated, endorsed or sponsored by CipSoft GmbH. TibiaME and Tibia are registered trademarks of CipSoft GmbH.',
    legalDesc2: 'The use of automation tools may violate the game\'s Terms of Service. Use at your own risk.',
    version: 'Unity-BOT v3.0 BETA',
    copyright: '© 2026 Unity-BOT Team',
  },
  auth: {
    enterRealm: 'Enter the Realm',
    joinGuild: 'Join the Guild',
    verifyEmail: 'Verify Your Email',
    recoverAccount: 'Recover Your Account',
    createNewPassword: 'Create New Password',
    setNewPassword: 'Set New Password',
    authentication: 'Authentication',
    enter: 'Enter',
    createAccount: 'Create Account',
    sendResetLink: 'Send Reset Link',
    verifyEmailBtn: 'Verify Email',
    resetPassword: 'Reset Password',
    setNewPasswordBtn: 'Set New Password',
    submit: 'Submit',
    username: 'Username',
    usernamePlaceholder: 'Enter your username',
    email: 'Email',
    emailPlaceholder: 'Enter your email',
    forgotEmailPlaceholder: 'Enter your account email',
    password: 'Password',
    passwordPlaceholder: 'Enter your password',
    newPassword: 'New Password',
    newPasswordPlaceholder: 'Enter your new password',
    changePasswordPlaceholder: 'Create a new password',
    strongPasswordHint: 'Choose a strong password you haven\'t used before.',
    confirmPassword: 'Confirm Password',
    confirmPasswordPlaceholder: 'Confirm your password',
    forgotHint: 'We\'ll send a password reset link to this email address.',
    verificationCode: '6-Digit Verification Code',
    verificationCodePlaceholder: '000000',
    codeSentTo: 'Enter the 6-digit code sent to',
    attemptsRemaining: '{n} attempt{s} remaining',
    resendCode: 'Didn\'t receive the code? Resend',
    codeExpired: 'Code expired - Click to get new code',
    forgotPassword: 'Forgot your password?',
    noAccount: 'Don\'t have an account?',
    haveAccount: 'Already have an account?',
    login: 'Login',
    rememberPassword: 'Remember your password?',
    backToLogin: 'Back to Login',
    needToGoBack: 'Need to go back?',
    loginFailed: 'Login failed',
    registrationFailed: 'Registration failed',
    registrationSuccess: 'Registration successful! Check your email for a 6-digit verification code.',
    emailNeedsVerification: 'Your email needs to be verified. Check your inbox for the verification code.',
    passwordIsTemporary: 'Your password is temporary. Please set a new password.',
    verificationFailed: 'Email verification failed',
    verificationSuccess: 'Email verified successfully! You can now login.',
    verificationCodeExpired: 'Verification code has expired. Please request a new one.',
    resendSuccess: 'New verification code sent! Check your email.',
    resendFailed: 'Failed to resend verification code',
    usernameNotFound: 'Username not found. Please register again.',
    validEmailRequired: 'Please enter a valid email',
    passwordsDoNotMatch: 'Passwords do not match',
    passwordMinLength: 'Password must be at least 6 characters',
    resetLinkSent: 'Password reset link has been sent to your email. Please check your inbox and spam folder. The link will expire in 1 hour.',
    resetLinkFailed: 'Unable to process your request. Please verify your email and try again.',
    invalidResetLink: 'Invalid reset link. Please request a new password reset.',
    resetSuccess: 'Password has been reset successfully! You can now login with your new password.',
    resetFailed: 'Failed to reset password. The link may have expired.',
    changePasswordFailed: 'Failed to change password',
    unexpectedError: 'An unexpected error occurred. Please try again.',
    loading: 'Loading...',
  },
  account: {
    title: 'Account',
    leave: 'Leave',
    setNickname: '+ Set nickname',
    editNickname: 'Edit nickname',
    save: 'Save',
    cancel: 'Cancel',
    aka: 'aka "{nickname}"',
    retry: 'Retry',
    nicknameEmpty: 'Nickname cannot be empty',
    nicknameMax: 'Nickname must be at most 30 characters',
    nicknameMin: 'Nickname must be at least 3 characters',
    nicknameBrackets: 'Nickname cannot use square brackets at the beginning or end',
    nicknameSpaces: 'Nickname cannot contain multiple consecutive spaces or special whitespace',
    nicknameChars: 'Nickname can only contain letters, numbers, spaces, hyphens and underscores',
    nicknamePrefix: 'Nickname cannot start with "{prefix}"',
    nicknameForbidden: 'This nickname contains forbidden words or patterns',
    nicknameProfanity: 'Nickname cannot contain inappropriate language',
    nicknameRepetitive: 'Nickname contains repetitive or invalid patterns',
    nicknameUppercase: 'Nickname cannot be mostly uppercase',
    nicknameSystem: 'Nickname cannot contain system-related words',
    free: 'Free',
    licensed: 'Licensed',
    admin: 'Admin',
    active: 'Active',
    inactive: 'Inactive',
    suspended: 'Suspended',
    banned: 'Banned',
    unknown: 'Unknown',
    appOnline: 'APP: Online',
    appOffline: 'APP: Offline',
    siteOnline: 'Site: Online',
    siteOffline: 'Site: Offline',
    appTooltip: 'APP (Unity-BOT)',
    siteTooltip: 'Site (Website)',
    updating: 'Updating...',
    updated: 'Updated {time}',
    info: 'Info',
    email: 'Email:',
    accountStatus: 'Account Status:',
    reason: 'Reason:',
    until: 'Until:',
    bannedBy: 'Banned by:',
    lastActivity: 'Last Activity:',
    lastIp: 'Last IP:',
    verifAttempts: 'Verif. Attempts:',
    licenseNotes: 'License Notes:',
    activeSessions: 'Active Sessions:',
    botConfigs: 'Bot Configs:',
    tg: 'TG:',
    bind: 'Bind:',
    uc: 'UC:',
    li: 'LI:',
    emailVerified: 'Email Verified:',
    yes: 'Yes',
    no: 'No',
    resendVerification: 'Resend verification email',
    sending: 'Sending...',
    verificationSent: 'Verification email sent!',
    verificationFailed: 'Failed to send verification email',
    verificationFailed2: 'Could not send verification email. Try again later.',
    availableTabs: 'Available Tabs:',
    temp: '+{n} temp',
    permanent: 'Permanent:',
    activePackages: 'Active Packages:',
    tabs: '{n} tabs',
    expires: 'expires {date}',
    addedByAdmin: 'Added by admin',
    characters: 'Characters:',
    charsCount: '{count} ({online} online)',
    memberSince: 'Member Since:',
    memberForYears: 'Member for {y}y {m}m',
    memberForMonths: 'Member for {m}m',
    memberForDays: 'Member for {d}d',
    memberForLess: 'Member for < 1d',
    lastLogin: 'Last Login:',
    never: 'Never',
    na: 'N/A',
    justNow: 'just now',
    minsAgo: '{n}m ago',
    hoursAgo: '{n}h ago',
    daysAgo: '{n}d ago',
    monthsAgo: '{n}mo ago',
    charsTab: 'Characters',
    loadingChars: 'Loading characters',
    noChars: 'No characters found',
    noCharsHint: 'Characters will appear here when created in-game',
    clickForDetails: 'Click to view details',
    online: 'Online',
    offline: 'Offline',
    level: 'Level {n}',
    security: 'Security',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    passwordPlaceholder: '••••••••',
    changing: 'Changing...',
    changePwBtn: 'Change Password',
    allFieldsRequired: 'All fields are required',
    newPasswordMin: 'New password must be at least 6 characters',
    newPasswordMismatch: 'New passwords do not match',
    passwordChanged: 'Password changed successfully!',
    changePwFailed: 'Failed to change password',
    changePwError: 'An error occurred. Please try again.',
    buyTabs: 'Buy Tabs',
    configurePackage: 'Configure your Package',
    tabQuantity: 'Tab Quantity',
    durationMonths: 'Duration (Months)',
    presetBasic: 'Basic',
    presetPopular: 'Popular',
    presetPremium: 'Premium',
    presetUltimate: 'Ultimate',
    orderSummary: 'Order Summary',
    package: 'Package',
    packageDesc: '{n} tab{s} × {n} month{s}',
    baseValue: 'Base Value',
    discount: '-R$ {amount}',
    total: 'Total',
    savingTip: 'Tip: More months = More savings!',
    processing: 'Processing...',
    buyFor: 'Buy for R$ {amount}',
    selectPackageFirst: 'Please select the quantity of tabs and duration',
    purchaseFailed: 'Failed to process order. Please try again or contact support.',
    purchaseSuccess: 'Order confirmed! Make payment via PIX to activate your tabs.',
    pixTitle: 'Scan the QR code or copy the code below',
    pixValue: 'Value:',
    pixDesc: '{tabs} tab{s} for {months} month{s}',
    pixCode: 'PIX Code (Copy & Paste)',
    withValue: 'With Value',
    copyCode: 'Copy full PIX code',
    copied: 'Copied!',
    copy: 'Copy',
    howToPay: 'How to Pay',
    step1: 'Open your banking app',
    step2: 'Choose PIX → Copy & Paste',
    step3: 'Paste the PIX code copied above',
    step4: 'Check the amount of R$ {amount}',
    step5: 'Complete the payment',
    step6: 'Contact support to confirm',
    paymentConfirmation: 'Payment Confirmation',
    paymentConfirmText: 'After making the payment, get in touch to activate your tabs:',
    backToPackages: 'Back to Packages',
    securePayment: 'Secure Payment: Use PIX for instant and secure transfer.',
    fastActivation: 'Fast Activation: Your tabs will be activated within 24 hours after confirmation.',
    support: 'Support: We are here to help via WhatsApp or Email.',
    whatsAppMsg: 'Hello! I would like to confirm my payment of R$ {amount} for {tabs} tab(s) for {months} month(s). My account: "{username}", awaiting reply. Thank you!',
    emailSubject: 'Payment Confirmation - Unity Tabs',
    emailBody: 'Hello,\n\nI made the payment of R$ {amount} via PIX for {tabs} tab(s) for {months} month(s).\n\nPIX Key: {key}\n\nAwaiting confirmation.\n\nThank you! My account: "{username}"',
    unityBot: 'Unity-BOT',
    version: 'Version {v}',
    installerAvailable: 'Installer Available',
    yes: 'Yes',
    no: 'No',
    size: 'Size',
    published: 'Published',
    fullInstaller: 'Full Installer',
    downloading: 'Downloading...',
    updatePatch: 'Update Patch',
    recentUpdates: 'Recent Updates',
    new: 'NEW',
    showLess: 'Show Less',
    showAll: 'Show All Updates ({n} more)',
    botConfig: 'Bot Config',
    telegram: 'Telegram',
    binds: 'Binds',
    unreal: 'Unreal',
    lifeIns: 'Life Ins.',
    savedTelegram: 'Saved Telegram Configs ({n})',
    noTelegram: 'No telegram configs',
    tab: 'Tab {name}',
    savedBinds: 'Saved Binds ({n})',
    noBinds: 'No bind configs',
    bindEntry: '{name}@{world}',
    bindType: '[{type}] {path}',
    savedCredentials: 'Saved Credentials ({n})',
    noCredentials: 'No credentials',
    credentialEntry: '{name}@{world}',
    passwordSaved: 'Password saved',
    savedPreferences: 'Saved Preferences ({n})',
    noPreferences: 'No preferences',
    prefEntry: '{char}@{world}',
    prefValue: 'Value: {data}',
    supportTab: 'Support',
    contactSupport: 'Contact Support',
    whatsApp: 'WhatsApp',
    email: 'Email',
    serverStatus: 'Server Status',
    loadingServer: 'Loading server status...',
    estimatedRecovery: 'Estimated recovery: {date}',
    quickFaq: 'Quick FAQ',
    faq1q: 'How do I activate my tabs after purchase?',
    faq1a: 'Contact us via WhatsApp or Email with your payment receipt. Tabs are usually activated within 24 hours.',
    faq2q: 'Where can I download the bot?',
    faq2a: 'Go to the Unity-BOT tab in this panel to download the full installer or update patch.',
    faq3q: 'How do I get a refund?',
    faq3a: 'Contact our support team via WhatsApp or Email. Refunds are processed on a case-by-case basis.',
    faq4q: 'Why was my account suspended?',
    faq4a: 'Check the Info tab for details about your account status. If you believe this is a mistake, contact support.',
    loadProfileFailed: 'Failed to load profile',
    loadInfoFailed: 'Could not load account information',
    nicknameUpdated: 'Nickname updated successfully!',
    nicknameUpdateFailed: 'Failed to update nickname',
    errorTryAgain: 'An error occurred. Please try again.',
    errorOccurred: 'An error occurred',
  },
  admin: {
    panelTitle: 'Admin Panel',
    clients: 'Clients',
    server: 'Server',
    stats: 'Stats',
    bot: 'Unity-BOT',
    resources: 'Resources',
    gms: 'GMs',
    news: 'News',
    dashboard: 'Dashboard',
    overview: 'Overview',
    accounts: 'Accounts',
    onlineActivity: 'Online Activity',
    characters: 'Characters',
    liveWorld: 'Live World',
    licenses: 'Licenses',
    gameMasters: 'Game Masters',
    totalAccounts: 'Total Accounts',
    onlineNow: 'Online Now',
    app: 'APP',
    site: 'Site',
    totalChars: 'Total Characters',
    online: 'online',
    unique: 'unique',
    noDuplicates: 'no duplicates',
    totalGMs: 'Total GMs',
    active: 'active',
    statusBreakdown: 'Status Breakdown',
    accountInfo: 'Account Info',
    emailVerified: 'Email verified',
    withNickname: 'With nickname',
    withLicense: 'With license',
    created: 'Created ({period})',
    createdShort: 'Created',
    appOnline: 'App Online',
    siteOnline: 'Site Online',
    charsOnline: 'Characters Online',
    perWorld: 'Per World',
    noWorlds: 'No worlds found',
    avgPerAccount: 'Avg per account',
    withoutChars: 'Without chars',
    uniqueChars: 'Unique chars',
    onlineNow_: 'Online now',
    population: 'Population',
    totalCharacters: 'Total Characters',
    activeAccounts: 'Active Accounts',
    licenseSummary: 'License Summary',
    licensesIssued: 'Licenses issued',
    permanentTabs: 'Permanent tabs',
    newTabPackages: 'NewTab Packages',
    totalPackages: 'Total packages',
    activePackages: 'Active packages',
    expired: 'Expired',
    activeQuantity: 'Active quantity',
    activeGMs: 'Active',
    seenToday: 'Seen Today',
    seenThisWeek: 'Seen This Week',
    in24h: 'in 24h',
    of: 'of',
    period24h: '24h',
    period7d: '7 days',
    period30d: '30 days',
    periodAll: 'All time',
    noData: 'No data',
    // Clients tab
    registeredClients: 'Registered Clients ({n})',
    totalClients: 'Total Clients',
    bannedSuspended: 'Banned/Suspended',
    verifiedEmail: 'Verified Email',
    appOnlineShort: 'App Online',
    siteOnlineShort: 'Site Online',
    totalCharsShort: 'Total Characters',
    avgClient: 'avg/client',
    charsOnlineShort: 'Chars Online',
    without: 'without',
    uniqueCharsShort: 'Unique Chars',
    pax: 'PAX',
    gmsActive: 'GMs Active',
    gmsCount: '{n} GM{s}',
    online: 'Online:',
    all: 'All',
    both: 'Both',
    search: 'Search by username, email...',
    filters: 'Filters',
    status: 'Status',
    characters_: 'Characters:',
    withChars: 'With Characters',
    withoutChars_: 'Without',
    sort: 'Sort:',
    created: 'Created',
    lastLogin: 'Last Login',
    username: 'Username',
    previous: 'Previous',
    next: 'Next',
    page: 'Page {n} of {total}',
    // Server tab
    serverControl: 'Server Control',
    changeStatus: 'Change Server Status',
    statusMessage: 'Status Message (Optional)',
    messagePlaceholder: 'e.g., Scheduled maintenance for updates',
    estimatedRecovery_: 'Estimated Recovery (Optional)',
    currentStatus: 'Current Status',
    modifiedBy: 'Modified by',
    serverOnline: 'Online',
    serverOnlineDesc: 'Normal operation',
    serverDegraded: 'Degraded',
    serverDegradedDesc: 'Reduced performance',
    serverUpdating: 'Updating',
    serverUpdatingDesc: 'Installing updates',
    serverRestarting: 'Restarting',
    serverRestartingDesc: 'Restarting services',
    serverMaintenance: 'Maintenance',
    serverMaintenanceDesc: 'Under maintenance',
    serverOffline: 'Offline',
    serverOfflineDesc: 'Server is offline',
    lastUpdated: 'Last updated:',
    // Stats
    overview_: 'Overview',
    onlineActivity_: 'Online Activity',
    characters_: 'Characters',
    worlds: 'Worlds',
    // Client details
    clientDetails: 'Client Details',
    infoTab: 'Info',
    charactersTab: 'Characters',
    sessionsTab: 'Sessions',
    actionsTab: 'Actions',
    manageTabs: 'Manage Tabs',
    ban: 'Ban',
    unban: 'Unban',
    deleteClient: 'Delete Client',
    editDetails: 'Edit Details',
    forceLogout: 'Force Logout',
    editLicenseNotes: 'Edit License Notes',
    noSessions: 'No sessions found',
    sessionType: 'Type',
    device: 'Device',
    ip: 'IP',
    active_: 'Active',
    revoked: 'Revoked',
    noCharacters: 'No characters found',
    charsHint: 'Characters will appear here when created in-game',
    clickForDetails: 'Click to view details',
    unknownWorld: 'Unknown',
    activeSessionsTitle: 'Active Sessions',
    noSessionHistory: 'No session history',
    sessionLast: 'Last:',
    sessionCreated: 'Created:',
    sessionRevoked: 'Revoked:',
    sessionDevice: 'Device/Browser',
    sessionIp: 'IP Address',
    sessionType: 'Type:',
    sessionIpLabel: 'IP:',
    adminActions: 'Admin Actions',
    banClient: 'Ban Client',
    unbanClient: 'Unban Client',
    licenseNotes: 'License Notes',
    verifyEmail: 'Verify Email',
    resetPassword: 'Reset Password',
    revokeAllSessions: 'Revoke All Sessions',
    activateSuccess: 'Client activated successfully',
    activateFail: 'Failed to activate client',
    banSuccess: 'Client banned successfully',
    banFail: 'Failed to ban client',
    verifyEmailSuccess: 'Email verified successfully',
    verifyEmailFail: 'Failed to verify email',
    revokeSuccess: 'Sessions revoked successfully',
    revokeFail: 'Failed to revoke sessions',
    updateDetailsSuccess: 'Client details updated successfully',
    updateDetailsFail: 'Failed to update client',
    passwordResetSuccess: 'Password reset successfully',
    passwordResetFail: 'Failed to reset password',
    licenseNotesUpdateSuccess: 'License notes updated successfully',
    licenseNotesUpdateFail: 'Failed to update license notes',
    deleteConfirmMismatch: 'Username does not match. Please type the exact username to confirm.',
    deleteFail: 'Failed to delete client',
    confirmDeleteTitle: 'Confirm Client Deletion',
    editClientDetails: 'Edit Client Details',
    deleteForever: 'Delete Forever',
    revokeTitle: 'Revoke all active sessions for',
    revokeConfirm: 'to proceed:',
    revokeDesc: 'The client will be immediately disconnected from all devices and will need to log in again.',
    typeConfirm: 'Type',
    typeConfirmHere: 'Type',
    here: 'here',
    noActiveSessions: 'No active sessions found',
    total: 'Total:',
    sessionCount: 'active session(s)',
    appSessions: 'APP session(s)',
    siteSessions: 'Site session(s)',
    currentValues: 'Current Values',
    newUsername: 'New Username',
    newEmail: 'New Email',
    saveChanges: 'Save Changes',
    resetPwWarning: 'This will instantly change the client\'s password. They will be unable to log in with their old password.',
    newTempPassword: 'New Temporary Password',
    minChars: 'Min 6 characters',
    hidePassword: 'Hide password',
    showPassword: 'Show password',
    weak: 'Weak',
    medium: 'Medium',
    strong: 'Strong',
    resetPwHint: 'The client will need to use this password on next login',
    currentPermanentTabs: 'Current permanent tabs',
    editNotesPlaceholder: 'e.g., payment terms, special conditions, support notes...',
    charCount: '/ 500 characters',
    saveNotes: 'Save Notes',
    couldNotLoadClient: 'Could not load client information',
    deleteIrreversible: 'This action cannot be undone!',
    deleteMessage: 'You are about to permanently delete the client',
    removeAssociated: 'This will remove all associated data including:',
    deleteItemAccount: 'User account and credentials',
    deleteItemChars: 'All characters owned by this user',
    deleteItemLicense: 'License information',
    deleteItemHistory: 'Activity history and logs',
    manageTabsDesc: 'Add or remove client tabs',
    banDesc: 'Suspend or permanently ban',
    inactiveDesc: 'Waiting for email verification',
    unbanDesc: 'Restore client access',
    deleteDesc: 'Permanently remove account',
    editDetailsDesc: 'Change username or email',
    verifyEmailDesc: 'Manually mark email as verified',
    resetPasswordDesc: 'Set a temporary password',
    forceLogoutDesc: 'Revoke all active sessions',
    licenseNotesDesc: 'Edit license observations',
    // Bot Manager
    overview: 'Overview',
    installer: 'Installer',
    versions: 'Versions',
    changelog: 'Changelog',
    // Resources
    manageFiles: 'Manage Files',
    uploadFiles: 'Upload Files',
    map: 'Map',
    // GMs
    gmStats: 'GM Stats',
    addGM: 'Add GM',
    editGM: 'Edit GM',
    deleteGM: 'Delete GM',
    gmName: 'Name',
    gmNotes: 'Notes',
    gmActive: 'Active',
    gmInactive: 'Inactive',
    showInactive: 'Show inactive/expired',
    noGMs: 'No Game Masters spotted recently',
    // Announcements
    createAnnouncement: 'Create Announcement',
    editAnnouncement: 'Edit Announcement',
    deleteAnnouncement: 'Delete Announcement',
    title: 'Title',
    content: 'Content',
    type: 'Type',
    priority: 'Priority',
    publishDate: 'Publish Date',
    expirationDate: 'Expiration Date',
    // Bot Manager
    newVersion: '+ New Version',
    createVersion: 'Create Version',
    creating: 'Creating...',
    versionCreated: 'created successfully',
    versionDeleted: 'deleted',
    versionUnpublished: 'unpublished',
    mandatory: 'MANDATORY',
    mandatoryUpdate: 'Mandatory Update',
    hide: 'Hide',
    publish: 'Publish',
    unpublish: 'Unpublish',
    edit: 'Edit',
    editChangelog: 'Edit Changelog',
    downloadZip: 'Download ZIP',
    publishConfirm: 'Publish {label} {version}? It will become publicly available.',
    unpublishConfirm: 'Unpublish version {version}? It will be removed from public access.',
    deleteVersionConfirm: 'Delete version {version}? This cannot be undone and will delete all associated files.',
    changelogUpdated: 'Changelog updated for v{version}',
    changelogUpdateFailed: 'Failed to update changelog',
    changelogPerLine: '(one change per line)',
    versionPlaceholder: 'e.g. {example}',
    versionRequired: 'Version and Changelog are required',
    updatePatchRequired: 'Update patch file is required',
    createVersionFailed: 'Failed to create version',
    createVersionError: 'Failed to create version: {error}',
    publishFailed: 'Failed to publish',
    unpublishFailed: 'Failed to unpublish',
    deleteVersionFailed: 'Failed to delete',
    // Installer
    selectInstallerFile: 'Please select an installer file (.exe)',
    installerUploaded: 'Installer uploaded: {size}',
    installerUploadFailed: 'Failed to upload installer',
    installerUploadError: 'Failed to upload installer: {error}',
    onlyExeAllowed: 'Only .exe files are allowed',
    installerDesc1: 'The installer is',
    installerDescBold: 'independent from versions',
    installerDesc2: 'Upload a new .exe file to replace the current installer. This will affect all new downloads from the public download page.',
    installerFileLabel: 'Installer File (.exe)',
    installerDropzoneText: 'Click to select or drag & drop installer file',
    installerDropzoneHint: 'Only .exe files (max 500 MB)',
    uploading: 'Uploading...',
    filesSelected: '{n} file(s) selected',
    filesDropzoneText: 'Click to select or drag & drop update files',
    filesDropzoneHint: 'Optional \u2022 DLLs, configs, etc \u2022 Max 50 files',
    willBeZipped: '(will be zipped)',
    changelogPlaceholder: "Fixed crash on inventory open\nAdded new map support\nPerformance improvements",
    shareUpdate: 'Share this update',
    // Resources Manager
    failedToLoadMapStatus: 'Failed to load map status',
    confirmMapUpload: 'Upload "{filename}" as map.bin? This will replace the current map.',
    mapUploadedSuccessfully: 'Map uploaded successfully! ({size})',
    failedToUploadMap: 'Failed to upload map',
    mapDownloadStarted: 'Map download started!',
    failedToDownloadMap: 'Failed to download map',
    filesRejected: '{count} file(s) rejected: {description} only accepts {extensions}',
    onlyBinFilesAllowed: 'Only .bin files are allowed for map upload',
    notAvailable: 'N/A',
    failedToLoadManifest: 'Failed to load manifest',
    pleaseSelectAtLeastOneFile: 'Please select at least one file to upload',
    allFilesUploadedSuccessfully: 'All {count} file(s) uploaded successfully!',
    allFilesFailedToUpload: 'All {count} file(s) failed to upload',
    someFilesUploadedWithFailures: '{successCount} file(s) uploaded, {failureCount} failed',
    failedToUploadFiles: 'Failed to upload files',
    confirmDeleteFile: 'Are you sure you want to delete "{filename}" from {category}?',
    fileDeletedSuccessfully: 'File "{filename}" deleted successfully!',
    failedToDeleteFile: 'Failed to delete file',
    noFilesToDeleteInCategory: 'No files to delete in this category',
    confirmDeleteAllFiles: '⚠️ DELETE ALL FILES?\n\nThis will permanently delete ALL {count} file(s) from {category}.\n\nThis action cannot be undone!',
    deleteAllFilesTitle: 'Delete All Files',
    categoryDeletedSuccessfully: 'Successfully deleted {count} file(s) from {category}!',
    failedToDeleteCategoryFiles: 'Failed to delete category files',
    confirmSyncFilesystem: 'Sync filesystem to database? This will scan all files and update the database.',
    filesystemSyncedSuccessfully: 'Filesystem synced successfully!',
    failedToSyncFilesystem: 'Failed to sync filesystem',
    preparingDownload: 'Preparing download...',
    downloadStarted: 'Download started!',
    failedToDownloadResources: 'Failed to download resources',
    clickToSelectOrDragDropFiles: 'Click to select or drag & drop files here',
    clearAll: 'Clear all',
    filesSelected: '{count} file(s) selected',
    uploadFilesWithCount: 'Upload {count} File(s)',
    confirmUpload: 'Confirm Upload',
    files: 'files',
    willBeUploaded: 'will be uploaded',
    cancel: 'Cancel',
    uploading: 'Uploading...',
    results: 'Results',
    successfulCount: '✅ {count} Successful',
    failedCount: '❌ {count} Failed',
    mapStatus: 'Map Status',
    downloadMapBin: 'Download map.bin',
    mapNotAvailable: 'Map not available',
    refresh: 'Refresh',
    file: 'File',
    mapBinPresent: '✅ map.bin present',
    noMapUploaded: '⚠️ No map uploaded',
    size: 'Size',
    lastModified: 'Last modified',
    tilesInQueue: 'Tiles in queue',
    clickRefreshToLoadMapStatus: 'Click refresh to load map status',
    uploadMapBin: 'Upload map.bin',
    mapUploadDescReplaces: 'Replaces the current authoritative',
    mapUploadDescFormat: 'Format: raw binary',
    clickToSelectOrDragDropBin: 'Click to select or drag & drop .bin file',
    deleteAllFromCategory: 'Delete all {count} file(s) from {category}',
    deleteAll: 'Delete All',
    noFilesInThisCategory: 'No files in this category',
    deleteFile: 'Delete file',
    categoryFileCount: '({count})',
    category: {
      java: 'Java archives (Client)',
      lib: 'Library DLLs (Bot)',
      x32: 'x32 DLLs (Client)',
      x64: 'x64 DLLs (Client)',
      audio: 'Audio files (Bot)',
      ui: 'UI configuration files (Client)',
      packs: 'Resource packs (Client)',
    },
    // GMs
    gmLoadFail: 'Failed to load GMs',
    gmNameRequired: 'Name is required',
    gmUpdateSuccess: 'GM updated',
    gmCreateSuccess: 'GM created',
    gmSaveFail: 'Failed to save GM',
    gmDeleteConfirm: 'Delete GM "{name}"?',
    gmDeleteUndoable: 'This action cannot be undone.',
    gmDeleteSuccess: 'GM "{name}" deleted',
    gmDeleteFail: 'Failed to delete GM',
    // Announcements
    annLoadFail: 'Failed to load announcements',
    annTitleContentRequired: 'Title and content are required',
    annUpdateSuccess: 'Announcement updated',
    annCreateSuccess: 'Announcement created',
    annSaveFail: 'Failed to save announcement',
    annDeleteConfirm: 'Delete announcement "{title}"?',
    annDeleteUndoable: 'This cannot be undone.',
    annDeleteSuccess: '"{title}" deleted',
    annDeleteFail: 'Failed to delete',
    alert: 'Alert',
    // Remaining admin keys
    failedToLoadData: 'Failed to load data',
    serverStatusChanged: 'Server status changed to {status} successfully!',
    updateStatusFailed: 'Failed to update server status',
    updateStatusError: 'An error occurred while updating server status',
    tabsHeader: 'Tabs',
    botDataLoadFailed: 'Failed to load bot data',
  },
  server: {
    online: 'Online',
    offline: 'Offline',
    maintenance: 'Maintenance',
    updating: 'Updating',
    degraded: 'Degraded',
    restarting: 'Restarting',
    unknown: 'Unknown',
    justNow: 'Just now',
    minsAgo: '{n}m ago',
    hoursAgo: '{n}h ago',
    failedToLoad: 'Failed to load server status',
    appLabel: 'App',
    webLabel: 'Web',
    charsLabel: 'Chars',
  },
  announcements: {
    latestNews: 'Latest News',
  },
  character: {
    level: 'Level {n}',
    world: 'World {world}',
    unknown: 'Unknown',
    online: 'Online',
    offline: 'Offline',
    deleteTitle: 'Delete character',
    tabCharacter: 'Character',
    combat: 'Combat',
    automation: 'Automation',
    technical: 'Technical',
    hp: 'HP',
    mp: 'MP',
    experience: 'Experience',
    toNextLevel: 'To Next Level',
    gold: 'Gold',
    stamina: 'Stamina',
    lifeInsurance: 'Life Insurance',
    highscore: 'Highscore',
    guild: 'Guild',
    name: 'Name',
    rank: 'Rank',
    rankings: 'Rankings',
    pvpRank: 'PVP Rank',
    boosts: 'Boosts',
    epBoost: 'EP Boost',
    goldBoost: 'Gold Boost',
    itemBonusEP: 'Item Bonus EP',
    itemBonusGold: 'Item Bonus Gold',
    protections: 'Protections',
    hit: 'Hit',
    fire: 'Fire',
    ice: 'Ice',
    soul: 'Soul',
    lightning: 'Lightning',
    skills: 'Skills',
    attackSkill: 'Attack Skill',
    defenseSkill: 'Defense Skill',
    currentMonster: 'Current Monster',
    killedMonsters: 'Killed Monsters',
    script: 'Script',
    scriptName: 'Script Name',
    currentAction: 'Current Action',
    saCombo: 'SA Combo',
    saLine: 'SA Line',
    movementSpeed: 'Movement Speed',
    autoMove: 'Auto Move',
    autoSA: 'Auto SA',
    enabled: 'Enabled',
    disabled: 'Disabled',
    performance: 'Performance',
    expPerHour: 'EXP/Hour',
    goldPerHour: 'Gold/Hour',
    expReceived: 'EXP Received',
    goldReceived: 'Gold Received',
    session: 'Session',
    huntTime: 'Hunt Time',
    totalSteps: 'Total Steps',
    reloginTime: 'Relogin Time',
    lastDisconnect: 'Last Disconnect',
    connection: 'Connection',
    state: 'State',
    serverInfo: 'Server Info',
    premium: 'Premium',
    banStatus: 'Ban Status',
    bind: 'Bind',
    location: 'Location',
    x: 'X',
    y: 'Y',
    z: 'Z',
    identifiers: 'Identifiers',
    characterId: 'Character ID',
    clientId: 'Client ID',
    timestamps: 'Timestamps',
    created: 'Created',
    lastUpdated: 'Last Updated',
    confirmDelete: 'Confirm Delete',
    deleteMessage: 'Are you sure you want to delete {name} from World {world}?',
    deleteWarning: 'This action cannot be undone.',
    deleting: 'Deleting...',
    delete: 'Delete',
    deleteFailed: 'Failed to delete character. Please try again.',
    none: 'None',
  },
  tabs: {
    title: 'Tabs - {username}',
    totalTabs: 'Total Tabs',
    permanent: 'Permanent',
    temporary: 'Temporary',
    addTabs: 'Add Tabs',
    removeTabs: 'Remove Tabs',
    permanentOption: 'Permanent (∞)',
    temporaryOption: 'Temporary (⏳)',
    quantity: 'Quantity',
    expiresAt: 'Expires At',
    plus1Month: '+1 Month',
    plus6Months: '+6 Months',
    descriptionOptional: 'Description (Optional)',
    adding: 'Adding...',
    addTabsBtn: 'Add Tabs',
    removePermanentTabs: 'Remove Permanent Tabs',
    amountToRemove: 'Amount to Remove (Max: {n})',
    removeTabsBtn: 'Remove Tabs',
    temporaryTabPackages: 'Temporary Tab Packages',
    expired: 'Expired',
    active: 'Active',
    expires: 'Expires:',
    addedBy: 'Added by:',
    deletePackage: 'Delete Package',
    modifiedBy: 'Modified by:',
    lastUpdated: 'Last Updated:',
    created: 'Created:',
    noLicense: 'No license found for this client.',
    createLicense: 'Create License with Tabs',
    qtyMin1: 'Quantity must be at least 1',
    expirationRequired: 'Expiration date is required for temporary tabs',
    addSuccessPermanent: 'Added {n} permanent tabs successfully!',
    addSuccessTemporary: 'Added {n} temporary tabs successfully!',
    removeSuccess: 'Removed {n} permanent tabs successfully!',
    deleteSuccess: 'Newtab package deleted successfully!',
    updateSuccess: 'Newtab updated successfully!',
    addFailed: 'Failed to add tabs',
    removeFailed: 'Failed to remove tabs',
    deleteFailed: 'Failed to delete newtab',
    updateFailed: 'Failed to update newtab',
    loadFailed: 'Failed to load license data',
    removeConfirm: 'Remove {n} permanent tabs from {username}?',
    deleteConfirm: 'Delete this temporary tab package?',
    amountMin1: 'Amount must be at least 1',
    errorOccurred: 'An error occurred while adding tabs',
    errorRemove: 'An error occurred while removing tabs',
    errorDelete: 'An error occurred while deleting newtab',
    errorUpdate: 'An error occurred while updating newtab',
    descPlaceholder: 'e.g., Monthly subscription',
    label: 'Label',
    addedByAdmin: 'Added by admin',
    none: 'None',
    never: 'Never',
  },
  ban: {
    title: 'Ban Client: {username}',
    banType: 'Ban Type',
    permanentBan: 'Permanent Ban',
    permanentDesc: 'Client will be banned indefinitely',
    temporarySuspension: 'Temporary Suspension',
    temporaryDesc: 'Client will be unbanned automatically',
    reason: 'Reason (Optional)',
    reasonPlaceholder: 'Enter the reason for this ban (e.g., \'Violated terms of use\', \'Inappropriate behavior\')...',
    charCount: '{n}/500 characters',
    expirationDateTime: 'Expiration Date & Time',
    date: 'Date',
    time: 'Time',
    autoUnban: 'The client will be automatically unbanned at the specified date and time',
    preview: 'Preview',
    client: 'Client:',
    type: 'Type:',
    permanent: 'Permanent',
    temporary: 'Temporary',
    expires: 'Expires:',
    processing: 'Processing...',
    confirmBan: 'Confirm Ban',
  },
  confirm: {
    title: 'Confirm',
    confirm: 'Confirm',
  },
  share: {
    shareUpdate: 'Share Update',
    badgeLatest: 'LATEST',
    badgeUpdate: 'UPDATE',
    mandatory: 'MANDATORY',
    whatsNew: "✦ What's New ✦",
    whatsApp: 'WhatsApp',
    image: 'Image',
    copy: 'Copy',
    statusWhatsApp: 'Opened WhatsApp!',
    statusCopied: 'Text copied!',
    statusGenerating: 'Generating image...',
    statusDownloaded: 'Image downloaded!',
    statusError: 'Something went wrong',
    cardBrand: 'UNITY-BOT',
    na: 'N/A',
    whatsAppTitle: '🏰 *UNITY-BOT Update v{version}* 🏰',
    whatsAppChanges: '✨ *What\'s New:*',
    whatsAppDownload: '⬇️ Download: unity-bot.com',
  },
  langSwitcher: {
    pt: 'Português (BR)',
    en: 'English (US)',
  },
  loading: {
    loading: 'Loading...',
    carregando: 'Carregando...',
  },
  app: {
    errorTitle: 'Something went wrong',
    errorDesc: 'An unexpected error occurred',
    clearSession: 'Clear Session & Reload',
  },
}
